export default __webpack_public_path__ + "static/Wood-bb129735eb43b0e259e1b939dc81b3a8.png";